import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

const REGION = "us-east-2";
const IDENTITY_POOL_ID = "us-east-2:ef1d578a-8f02-4984-b15f-c5ade001a098";

export async function getCredentials() {
  try {
    const credentials = await fromCognitoIdentityPool({
      client: new CognitoIdentityClient({ region: REGION }),
      identityPoolId: IDENTITY_POOL_ID
    })();
    
    return credentials;
  } catch (error) {
    console.error('Error getting credentials:', error);
    throw error;
  }
}

export default async function getAwsConfig() {
  const credentials = await getCredentials();
  return {
    region: REGION,
    credentials
  };
}